<template>
    <div id="SkuList">
        <div class="SkuListItem" v-for="sku in skus">
            <a href="#">{{sku}}</a>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'TaskList',
        props: ['SkuList'],
        data() {
            return {
                skus: this.SkuList
            }
        }
    }
</script>
